import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getList({ searchParams, currentPage, pageUnit }) {
		try {
			const queryStr = objectToQueryString({
				strDt: searchParams.strDt,
				endDt: searchParams.endDt,
				partNo: searchParams.partNo,
				occuPlCd: searchParams.occuPlCd,
				currentPage,
				pageUnit
			});
			const response = await client.get(`${BASE_URL}/pqy/pcku/pprRptStts/v1/pprRptSttss${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
